export default __webpack_public_path__ + "static/media/DESIGNECOSTRUZIONEDIUNNUOVOEDIFICIOADIBITOAUFFICIESPOGLIATOI.034a76c9.pdf";